import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fc63bed8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "ml-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Maint Plan ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Maint Plan Desc"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Asset"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Stat Flag"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Num Done (last 12 months)")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

import { IndividualAssetManagementPlan } from "@/classes";
import type { Deleteable } from "@/classes/asset-management-plan";
import { ref } from "vue";

import RichText from "@/components/base/inputs/RichText.vue";
import { useConfirmStore } from "@/store/confirm";
import TooltipIcon from "@/components/base/tooltips/TooltipIcon.vue";
import { useAMPStore } from "@/store/asset-management-plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetManagementPlan',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useAMPStore();

const tab = ref(0);

const addPlan = () => {
  const plan = new IndividualAssetManagementPlan();
  plan.asset_management_plan = store.plan;
  plan.asset_management_plan_id = store.plan.id;
  store.plan.individual_asset_management_plans.push(plan);
};

const $confirm = useConfirmStore();

const deletePlan = (plan: IndividualAssetManagementPlan) => {
  $confirm.open({
    title: "Delete Plan?",
    confirmText: "Delete",
    color: "red",
    onConfirm: () => {
      if (
        tab.value ===
        store.plan.individual_asset_management_plans.length - 1
      ) {
        tab.value = Math.max(0, tab.value - 1);
      }
      store.plan.individual_asset_management_plans =
        store.plan.individual_asset_management_plans.filter(
          (p) => p.id !== plan.id
        );
      emit("delete", plan);
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_toolbar, {
      density: "compact",
      color: "grey-lighten-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).plan.individual_asset_management_plans, (plan, i) => {
              return (_openBlock(), _createBlock(_component_v_tab, { key: i }, {
                default: _withCtx(() => [
                  _createTextVNode(" Plan " + _toDisplayString(i + 1) + " ", 1),
                  (!plan.valid)
                    ? (_openBlock(), _createBlock(TooltipIcon, {
                        key: 0,
                        class: "ml-2",
                        text: "Please fill out all fields."
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (!_ctx.readonly)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  style: {"margin-left":"4px","margin-top":"6px"},
                  variant: "plain",
                  color: "secondary",
                  onClick: addPlan
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-plus")
                      ]),
                      _: 1
                    }),
                    _createTextVNode("Add ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider),
    _createVNode(_component_v_tabs_window, { "model-value": tab.value }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).plan.individual_asset_management_plans, (plan, i) => {
          return (_openBlock(), _createBlock(_component_v_tabs_window_item, {
            value: i,
            key: i
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                density: "compact",
                color: "grey-lighten-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Plan " + _toDisplayString(i + 1), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createTextVNode(),
                  _createVNode(_component_v_spacer),
                  (!_ctx.readonly)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "ma-2",
                        icon: "mdi-delete",
                        variant: "plain",
                        color: "red",
                        onClick: ($event: any) => (deletePlan(plan))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(RichText, {
                  modelValue: plan.management_consideration_factors,
                  "onUpdate:modelValue": ($event: any) => ((plan.management_consideration_factors) = $event),
                  label: `5.${i + 1}.1 Management Consideration Factors`,
                  class: "mb-4",
                  required: "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"]),
                _createVNode(RichText, {
                  modelValue: plan.condition_monitoring,
                  "onUpdate:modelValue": ($event: any) => ((plan.condition_monitoring) = $event),
                  label: `5.${i + 1}.2 Condition Monitoring`,
                  class: "mb-4",
                  required: "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"]),
                _createVNode(RichText, {
                  modelValue: plan.maintenance_defect_management,
                  "onUpdate:modelValue": ($event: any) => ((plan.maintenance_defect_management) = $event),
                  label: `5.${i + 1}.3 Maintenance & Defect Management`,
                  class: "mb-4",
                  required: "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"]),
                _createVNode(RichText, {
                  modelValue: plan.maintenance_plans,
                  "onUpdate:modelValue": ($event: any) => ((plan.maintenance_plans) = $event),
                  label: `5.${i + 1}.4 Maintenance Plans`,
                  class: "mb-4",
                  required: "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"]),
                _createVNode(_component_v_card, {
                  class: "mb-4",
                  variant: "outlined",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { density: "compact" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" 5." + _toDisplayString(i + 1) + ".5 Preventative Maintenance Tactics ", 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_spacer),
                        _createElementVNode("span", null, " # Assets Applied: " + _toDisplayString(_unref(store).preventativeMaintenance.num_assets_applied) + " / " + _toDisplayString(_unref(store).preventativeMaintenance.num_assets) + ", ", 1),
                        _createElementVNode("span", _hoisted_2, " # Compliance: " + _toDisplayString(_unref(store).preventativeMaintenance.num_workorders) + " / " + _toDisplayString(_unref(store).preventativeMaintenance.num_tactic_ops), 1),
                        _createVNode(_component_v_tooltip, {
                          text: "Refresh",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                              class: "ml-3",
                              icon: "mdi-reload",
                              density: "compact",
                              loading: _unref(store).fetchingPreventativeMaintenance,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).getPreventativeMaintenance()))
                            }), null, 16, ["loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_table, {
                      class: "tactics-table",
                      "fixed-header": "",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).preventativeMaintenance.tactics, (tactic, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("td", null, _toDisplayString(tactic.maint_plan_id), 1),
                              _createElementVNode("td", null, _toDisplayString(tactic.maint_plan_description), 1),
                              _createElementVNode("td", null, _toDisplayString(tactic.asset_name), 1),
                              _hoisted_4,
                              _createElementVNode("td", null, _toDisplayString(tactic.num_workorders) + " / " + _toDisplayString(tactic.num_tactic_ops), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(RichText, {
                  modelValue: plan.statutary_requirements,
                  "onUpdate:modelValue": ($event: any) => ((plan.statutary_requirements) = $event),
                  label: `5.${i + 1}.6 Statutary Requirements`,
                  class: "mb-4",
                  required: "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"]),
                _createVNode(RichText, {
                  modelValue: plan.equipment_decomissioning_disposal,
                  "onUpdate:modelValue": ($event: any) => ((plan.equipment_decomissioning_disposal) = $event),
                  label: `5.${i + 1}.7 Equipment Decomissioning & Disposal`,
                  class: "mb-4",
                  required: "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"]),
                _createVNode(RichText, {
                  modelValue: plan.capital_projects,
                  "onUpdate:modelValue": ($event: any) => ((plan.capital_projects) = $event),
                  label: `5.${i + 1}.8 Capital Projects`,
                  class: "mb-4",
                  required: "",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "readonly"])
              ])
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})